import {
  type ComponentProps,
  type ComponentType,
  CSSProperties,
  forwardRef,
} from 'react';
import cl from 'clsx';

import classes from './Button2.module.scss';

export type Button2Props = ComponentProps<'button'> & {
  PrefixIcon?: ComponentType<ComponentProps<'svg'>>;
  prefixIconClassName?: string;
  prefixIconStyle?: CSSProperties;
  SuffixIcon?: ComponentType<ComponentProps<'svg'>>;
  suffixIconClassName?: string;
  suffixIconStyle?: CSSProperties;
};

export const Button2 = forwardRef<HTMLButtonElement, Button2Props>(
  function Button2(
    {
      type = 'button',
      disabled, //styled in module.css

      PrefixIcon,
      prefixIconClassName,
      prefixIconStyle,

      children,

      SuffixIcon,
      suffixIconClassName,
      suffixIconStyle,

      className,

      ...rest
    },
    ref,
  ) {
    return (
      <button
        type={type}
        ref={ref}
        className={cl(classes.root, className)}
        disabled={disabled}
        {...rest}
      >
        {PrefixIcon && (
          <PrefixIcon className={prefixIconClassName} style={prefixIconStyle} />
        )}
        {children}
        {SuffixIcon && (
          <SuffixIcon className={suffixIconClassName} style={suffixIconStyle} />
        )}
      </button>
    );
  },
);
